import { observer } from 'mobx-react-lite'
import React from 'react'
import { CSS } from '../../../../lib/stitches'
import Table from './Table'

type Column = React.ReactElement | string
interface Columns {
  indicator?: Column
  avatar?: Column
  details?: Column
  visualizer?: Column
  genre?: Column
  remixCount?: Column
  actions?: Column
}

interface RowProps {
  columns: Columns
  isActive?: boolean
  onMouseOver?: () => void
  onMouseOut?: () => void
  onClick?: () => void
  css?: CSS
}

const Row: React.FC<RowProps> = ({ columns, isActive, onMouseOver, onMouseOut, onClick, css }) => (
  <Table.Row
    css={{ maxWidth: '100%', ...css }}
    active={isActive}
    onMouseOver={onMouseOver}
    onMouseOut={onMouseOut}
    onClick={onClick}
  >
    {columns.indicator}
    {columns.avatar}
    <Table.Col css={{ width: '160px', marginLeft: '14px', flex: 1 }}>{columns.details}</Table.Col>
    <Table.Col
      css={{
        flex: 1,
        marginLeft: '32px',
        width: '120px',
        display: 'none',
        '@bigscreen': { display: 'flex' }
      }}
    >
      {columns.visualizer}
    </Table.Col>
    <Table.Col
      css={{
        width: '120px',
        minWidth: '120px',
        marginLeft: '32px',
        display: 'none',
        '@tablet': { display: 'flex' }
      }}
    >
      {columns.genre}
    </Table.Col>
    <Table.Col
      css={{
        width: '80px',
        minWidth: '80px',
        marginLeft: '32px',
        display: 'none',
        '@tablet': { display: 'flex' },
        '@bigscreen': { width: '100px', minWidth: '100px' }
      }}
    >
      {columns.remixCount}
    </Table.Col>
    <Table.Col
      css={{
        marginLeft: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        minWidth: '120px',
        width: '120px',
        '@bigscreen': {
          minWidth: '160px',
          width: '120px'
        }
      }}
    >
      {columns.actions}
    </Table.Col>
  </Table.Row>
)

export default observer(Row)
